<template>
    <div class="o-video u-w100 u-py20 u-overflowYAuto">
        <div class="o-video__inner u-container">
            <div v-if="!loading" class="o-video__list">
                <div v-if="videos.videos.length > 0" class="o-video__items">
                    <div v-for="video in videos.videos" :key="video.id" class="o-video__item u-mb20">
                        <Video
                            v-if="video.video || video.image"
                            :item="{ video: video.video, image: video.image || '', title: video.title }"
                        />
                    </div>
                </div>
                <div v-else class="o-video__empty">
                    {{ t('knowledgebase.noVideos') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '../services/api';

// Components
import Video from '../components/molecules/Video.vue';

const videos = ref(null);
const loading = ref(true);
const currentId = inject('currentId');
const emit = defineEmits(['updateHeader']);
const { t } = useI18n();

const fetchVideos = async () => {
    try {
        const response = await api.get(`/videos/${currentId.value}`);

        if (response.status === 200) {
            videos.value = response.data;
            if (videos.value.module_title) {
                emit('updateHeader', videos.value.module_title);
            }
        }
    } catch (error) {
        console.error('Error fetching videos:', error);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchVideos();
});
</script>
